"use strict";
angular.module("backstageHeaderModule", [])
	.controller("backstageHeaderCtrl", ["$scope", "$state", "httpService", "$stateParams", function($scope, $state, httpService, $stateParams) {
		initStatus();
		initData();

		function initStatus() {
			$scope.data = {
				platformlogo:"",
			}
			$scope.authentication = {
				0: '审核中',
				1: '已认证',
				2: '认证失败'
			};
			$scope.authenticationClass = {
				0: 'unaudited',
				1: 'green',
				2: 'failure',
				3: 'twoAudit'
			};
			var i = $stateParams.type;
			switch(i) {
				case "0":
					$scope.type = "稿件详情";
					break;
				case "1":
					$scope.type = "新建公告";
					break;
				case "2":
					$scope.type = "编辑公告";
					break;
				case "3":
					$scope.type = "公告详情";
					break;
				case "4":
					$scope.type = "新建稿件";
					break;
				case "5":
					$scope.type = "编辑稿件";
					break;
				default:
					$scope.type = "";
			}
			$scope.info = {};
		}
		/**
		 * [getseconddomain description]获得admin 登录配置信息
		 * 
		 * @return {[type]} [description]
		 */
		function getseconddomain() {
			var params = {
				domainPrefix: '123'
			};
			httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", params, "post").then(function(data) {
				if(data.data.platformlogo==null){
					$scope.data.platformlogo ='images/logo.png';
				}else{
					$scope.data.platformlogo = JSON.parse(data.data.platformlogo)[0];
				}
				if(data.data.platformName==null) {
					$scope.data.platformName = '通讯员平台';
				} else {
					$scope.data.platformName = data.data.platformName;
				}
			});
		}

		function initData() {
			getLogin();
			getseconddomain();
			window.addEventListener("storage", function(e) {
				if(e.key === "ls.readMessage") {
					unReadMessages();
				}
			});
			$scope.$on("readMessage", function() {
				unReadMessages();
			});
		}
		/**
		 * [goToInformation description] 进入修改资料
		 * @return {[type]} [description]
		 */
		$scope.goToInformation = function() {
			var href = $state.href("index.settings.pgcmodifydata");
			window.open(href);
		};
		/**
		 * [logOut description] 注销
		 * @return {[type]} [description]
		 */
		$scope.logOut = function() {
			$.ajax({
				type: "post",
				headers:{requestToken:sessionStorage.getItem('requestToken')},
				url: "/mcnadmin/web/user/logout.do",
				async: false
			});
			$state.go("backstage", {}, {
				reload: "backstage"
			});
		};
		/**
		 * [getLogin description] 获取登入详细
		 * @return {[type]} [description]
		 */

		function getLogin() {
			httpService.http("/mcnadmin/web/user/getLoginUser.do", "", "post").then(function(data) {
				$scope.info = data.loginUser;
				var time = new Date().getTime();
				if(data.loginUser.logo) {
					$scope.headPic = angular.globalConfig.pictureServer + data.loginUser.logo + '?v=' + time;
				} else {
					$scope.headPic = './images/uperroe.png';
				}
				if(data.loginUser.userType == 1) {
					$scope.message = true;
					unReadMessages();
				} else {
					$scope.message = false;
				}
				if(data.signChannels) {
					$scope.authentication = true;
				}
			});
		}
	}]);